import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const RestoreMeetingPrepCardMutation = graphql(`
  mutation RestoreMeetingPrepCard($id: ID!) {
    restoreMeetingPrepCard(id: $id) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
      cardType
      reason
      status
      endedAt
    }
  }
`);

export function useRestoreMeetingPrepCard() {
  const [result, restoreMeetingPrepCardMutation] = useMutation(RestoreMeetingPrepCardMutation);
  const [error, setError] = useState<Error | null>(null);

  const restoreMeetingPrepCard = useCallback(
    async (id: string) => {
      try {
        const response = await restoreMeetingPrepCardMutation({ id });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.restoreMeetingPrepCard;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [restoreMeetingPrepCardMutation],
  );

  return { restoreMeetingPrepCard, result, error };
}
